import moment from 'moment';


export const dateDiff = (date1, date2) => {
	if (moment(date1, 'YYYY-MM-DD HH:mm:ss') > moment(date2, 'YYYY-MM-DD HH:mm:ss')) {
		return "+" + moment.utc(moment(date1, 'YYYY-MM-DD HH:mm:ss').diff(moment(date2, 'YYYY-MM-DD HH:mm:ss'))).format("DD HH");
	} else {
		return "-" + moment.utc(moment(date2, 'YYYY-MM-DD HH:mm:ss').diff(moment(date1, 'YYYY-MM-DD HH:mm:ss'))).format("DD HH");
	}
}

export const modifiedDate = (date) => {
	
	if (!date) {
		return "";
	}
	
	return (moment(date, 'YYYY-MM-DD HH:mm:ss').add(8, 'hours').format('D MMM h:mma'));
}

export const modifiedDateWithYear = (date) => {
	
	if (!date) {
		return "";
	}
	
	return (moment(date, 'YYYY-MM-DD HH:mm:ss').add(8, 'hours').format('D MMM YY h:mma'));
}

export const modifiedDateWithoutTime = (date) => {
	if (!date) {
		return null;
	}
	
	return (moment(date, 'YYYY-MM-DD HH:mm:ss').add(8, 'hours').format('YYYY-MM-DD'));	
}

export const getToday = () => {	
	return moment().format('YYYY-MM-DD');	
}

export const getTodayFull = () => {	
	return moment().format('YYYY-MM-DD HH:mm:ss');	
}

export const isValidYYYYMMDD = (date) => {
	return moment(date).isValid();
}


export const modifiedDateDayMonthOnly = (date) => {
	if (!date) {
		return null;
	}
	
	return (moment(date, 'YYYY-MM-DD HH:mm:ss').add(8, 'hours').format('D MMM'));	
}

export const getDateOnly = (date) => {
	if (!date) {
		return null;
	}
	
	return (moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'));	
}